import React, { useState } from 'react';
import { Tabs } from 'antd';
import { DatabaseOutlined, DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import PageHeader from '../../../components/shared/PageHeader';

// Import export/import tabs
import ExportData from './components/ExportData';
import ImportData from './components/ImportData';
import ExportHistory from './components/ExportHistory';
import ImportHistory from './components/ImportHistory';

const DataExportImport: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>('export');

  const tabItems = [
    {
      key: 'export',
      label: (
        <span>
          <DownloadOutlined />
          Export Data
        </span>
      ),
      children: <ExportData />,
    },
    {
      key: 'import',
      label: (
        <span>
          <UploadOutlined />
          Import Data
        </span>
      ),
      children: <ImportData />,
    },
    {
      key: 'export-history',
      label: (
        <span>
          <DownloadOutlined />
          Export History
        </span>
      ),
      children: <ExportHistory />,
    },
    {
      key: 'import-history',
      label: (
        <span>
          <UploadOutlined />
          Import History
        </span>
      ),
      children: <ImportHistory />,
    },
  ];

  return (
    <div>
      <PageHeader
        icon={<DatabaseOutlined />}
        title="Data Export/Import"
        subtitle="Export system data for backup or analysis, and import data from external sources"
      />

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        type="card"
        items={tabItems}
      />
    </div>
  );
};

export default DataExportImport; 